import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { PublicationService } from 'src/app/Service/publications.services';
declare var blueimp: any;
declare var $:any;


@Component({
  selector: 'app-videotheque',
  templateUrl: './videotheque.component.html',
  styleUrls: ['./videotheque.component.scss'],
})
export class VideothequeComponent implements OnInit, AfterViewInit {
  lgsub;
  routesub;
  currentUrl;
  outputLg;
  section;
  urlSection;
  currentlang;
  constructor(
    public global: Global,
    private service: PublicationService,
    private aroute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.lgsub = this.global.CurentLanguage.pipe(
      takeUntil(this.global.navigationEnd)
    ).subscribe((lg) => {
      this.outputLg = lg;
      this.routesub ? this.routesub.unsubscribe() : null;
      this.routesub = this.aroute.params.subscribe((param) => {

        this.currentlang = lg.url;
        this.currentUrl = this.router.url
        const url = this.router.url;

        this.currentUrl = this.router.url
        if (url.indexOf('/agence/') !== -1) {
          this.section = 'Agence';
          this.urlSection = '/agence/presentation'
        } else if (url.indexOf('/grands-chantiers/') !== -1) {
          this.section = 'Grands Chantiers';
          this.urlSection = '/grands-chantiers/chantiers-infrastructures'
        } else if (url.indexOf('/missions/') !== -1) {
          this.section = 'Missions';
          this.urlSection = '/missions/PortAuthorite'
        } else if (url.indexOf('/formation-portuaire/') !== -1) {
          this.section = 'Formation Portuaire';
          this.urlSection = '/formation-portuaire/ifp'
        } else if (url.indexOf('/services/') !== -1) {
          this.section = 'Services';
          this.urlSection = '/services/portnet'
        } else if (url.indexOf('/publications/') !== -1) {
          this.section = 'Publications';
          this.urlSection = '/publications/communiques-presse'
        } else if (url.indexOf('/espace-professionnel/') !== -1) {
          this.section = 'Espace Professionnel';
          this.urlSection = '/espace-professionnel/portnet'
        }
      });

    });
  }
  ngAfterViewInit() {
    this.service.getVideoTheque(this.outputLg.url).subscribe(datas => {
      const gallery = [];
      datas['value'].forEach(element => {
        const obj = {
          title: element.Title,
          type: 'text/html',
          href: element.Url,
          youtube: element.YoutubeId,

        }
        gallery.push(obj);
      });
      blueimp.Gallery(gallery, {
        container: '#blueimp-gallery-carousel',
        carousel: true,
        onopened : function(){
          let li = $('ol.indicator li')
          this.pause();
          for (let index = 0; index < li.length; index++) {
            const element = $(li[index]);
            element.html("<img src='https://img.youtube.com/vi/"+gallery[index].youtube+"/default.jpg' width='80px'/>")
            
          }
          // $('ol.indicator').appendTo( ".newol" );
        }
      });

    });

  }
  ngOnDestroy() {
    this.lgsub.unsubscribe();
  }
}
